import React from "react";

const trustItems = [
  {
    title: "24/7 Support",
    desc: "Always here for you",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[18px] w-[18px] text-[#22c55e]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2.2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 18v-6a9 9 0 0118 0v6M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3M3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3"
        />
      </svg>
    ),
  },
  {
    title: "Top Brands",
    desc: "Compare leading rental companies",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[18px] w-[18px] text-[#22c55e]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2.2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        />
      </svg>
    ),
  },
  {
    title: "Huge Fleet",
    desc: "From compact cars to SUVs",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[18px] w-[18px] text-[#22c55e]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2.2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h8a1 1 0 001-1z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 8h5.172a1 1 0 01.707.293l2.828 2.828a1 1 0 01.293.707V16a1 1 0 01-1 1h-8"
        />
        <circle cx="6.5" cy="16.5" r="1.5" fill="currentColor" />
        <circle cx="16.5" cy="16.5" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "Secure Payments",
    desc: "Your data is always safe",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[18px] w-[18px] text-[#22c55e]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2.2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        />
      </svg>
    ),
  },
];

const TrustBanner = () => {
  return (
    <div className="w-full bg-[#1e252b] font-sans py-6 mt-0 sm:mt-4">
      <div className="max-w-7xl mx-auto ">
        
        {/* Top Tiny Overhead Text Label */}
        <div className="text-center mb-8">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-gray-400/90">
            Trusted by thousands. Loved by travelers.
          </p>
        </div>

        {/* Four Column Trust Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-6 justify-items-start lg:justify-items-center">
          {trustItems.map((item, index) => (
            <div key={index} className="flex items-center gap-3.5 w-full max-w-[260px]">
              
              {/* Dark Translucent Muted Circle Icon wrapper */}
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#2a3239] flex items-center justify-center border border-gray-700/20">
                {item.icon}
              </div>

              {/* Text Area */}
              <div className="flex flex-col">
                <h4 className="text-[15px] font-bold text-white tracking-wide">
                  {item.title}
                </h4>
                <p className="text-[13px] text-gray-400/90 font-normal leading-tight mt-0.5 whitespace-nowrap">
                  {item.desc}
                </p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default TrustBanner;